<script setup="">
import { SmileIcon } from "lucide-vue-next";
import { ref } from "vue";
import EmojiPicker from "vue3-emoji-picker";

import { Popover, PopoverButton, PopoverPanel } from "@headlessui/vue";
import { onClickOutside } from "@vueuse/core";

const emit = defineEmits(["select"]);

const props = defineProps({
  show: {
    type: Boolean,
    default: false
  },
  native: {
    type: Boolean,
    default: true
  },
  hideSearch: {
    type: Boolean,
    default: false
  },
  hideGroupIcons: {
    type: Boolean,
    default: false
  },
  hideGroupNames: {
    type: Boolean,
    default: false
  },
  staticTexts: {
    type: Object,
    default: () => ({})
  },
  disableStickyGroupNames: {
    type: Boolean,
    default: false
  },
  disabledGroups: {
    type: Array,
    default: () => []
  },
  groupNames: {
    type: Object,
    default: () => ({})
  },
  disableSkinTones: {
    type: Boolean,
    default: false
  },
  text: {
    type: String,
    default: ""
  },
  mode: {
    type: String,
    default: "insert"
  },
  offset: {
    type: Number,
    default: 6
  },
  additionalGroups: {
    type: Object,
    default: () => ({})
  },
  groupOrder: {
    type: Array,
    default: () => []
  },
  groupIcons: {
    type: Object,
    default: () => ({})
  },
  pickerType: {
    type: String,
    default: ""
  },
  displayRecent: {
    type: Boolean,
    default: false
  },
  theme: {
    type: String,
    default: "light"
  }
});

const emojiRef = ref(null);
const isShow = ref(props.show);

const select = (emoji) => {
  emit("select", emoji);
  isShow.value = false;
};

onClickOutside(emojiRef, () => {
  isShow.value = false;
});
</script>

<template>
  <Popover as="div">
    <PopoverButton>
      <SmileIcon class="h-5 w-5 cursor-pointer" />
    </PopoverButton>

    <PopoverPanel class="absolute right-1 z-10 overflow-hidden rounded-xl border md:right-auto">
      <EmojiPicker
        ref="emojiRef"
        :native="native"
        :type="pickerType"
        :text="text"
        :mode="mode"
        :offset="offset"
        :additional-groups="additionalGroups"
        :hide-search="hideSearch"
        :hide-group-icons="hideGroupIcons"
        :hide-group-names="hideGroupNames"
        :static-texts="staticTexts"
        :disable-sticky-group-names="disableStickyGroupNames"
        :disabled-groups="disabledGroups"
        :group-names="groupNames"
        :disable-skin-tones="disableSkinTones"
        :group-order="groupOrder"
        :group-icons="groupIcons"
        :display-recent="displayRecent"
        :theme="theme"
        @select="select"
      />
    </PopoverPanel>
  </Popover>
</template>

<style>
@import "vue3-emoji-picker/css";
</style>
